var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{ref:"chart",staticClass:"container"}),_c('div',{staticClass:"total-income"},[_vm._v("停车缴费"),_c('br'),_c('span',{staticClass:"value"},[_vm._v("￥"+_vm._s(_vm.totalIncome))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }